import { Box, Container } from '@chakra-ui/react';
import { StarBackground } from '@components/StarBackground';
import { LANDING_ROUTES, pxToRem } from '@cyberkongz/ui';
import { getAllPosts, getPost } from '@features/blog/apiContentful';
import { BlogPost } from '@features/blog/BlogPost';
import { DEFAULT_BLOG_REVALIDATE_PERIOD } from '@features/blog/utils';
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next';
import { ParsedUrlQuery } from 'querystring';

export default function BlogPostPage({ post }: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <Box css={{ width: '100%' }}>
      <StarBackground
        stylesContainer={{
          pt: [pxToRem(86), pxToRem(182)],
        }}
        sxStarItem={{
          opacity: 0.3,
        }}
      >
        <Container>{post ? <BlogPost {...post} /> : 'Post Not Found'}</Container>
      </StarBackground>
    </Box>
  );
}

export async function getStaticProps({ params }: GetStaticPropsContext) {
  const post = await getPost((params as ParsedUrlQuery).slug as string);

  return {
    // will throw 404 page, to do infergetstaticprops to correctly resolve types
    notFound: post === null,
    props: {
      post,
    },
    revalidate: DEFAULT_BLOG_REVALIDATE_PERIOD,
  };
}

export async function getStaticPaths() {
  const paths = await getAllPosts();

  return {
    paths: paths.map(({ slug }) => LANDING_ROUTES.BLOG_POST(slug)) || [],
    fallback: true,
  };
}
